import React, { ReactNode, useEffect, useState } from "react";
import { RotatingLines } from "react-loader-spinner";
import { serviceRequests } from "../../../redux/service-requests/action";
import { useAppDispatch } from "../../../hooks/hooks";
import { useNavigate } from "react-router-dom";


export const TalkwithusForm: React.FC = () => {
    const dispatch = useAppDispatch();
    const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
    const [selectedAdvisor, setSelectedAdvisor] = useState<any>({});
    const navigate = useNavigate();
    const resetForm = () => {
        setSelectedAdvisor({
            RequestorName: "",
            RequestorEmailId: "",
            RequestorPhoneNo: "",
            Description: "",
            Subjects: "",
        });
    };

    const handleSubmit = async (event: any) => {
        event.preventDefault();

        dispatch(serviceRequests.resetAction({ actionType: 'create' }))
        dispatch(serviceRequests.update({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/service-desk/service-request`,
            entity: 'serviceRequests',
            jsonData: {
                Context: {},
                Records: [
                    {
                        "Id": 0,
                        "ServiceRequestTypeId": 10,
                        "ServiceRequestStatusId": 10,
                        "RequestorId": 0,
                        "RequestorName": selectedAdvisor?.RequestorName,
                        "RequestorEmailId": selectedAdvisor?.RequestorEmailId,
                        "RequestorPhoneNo": selectedAdvisor?.RequestorPhoneNo,
                        "Subject": selectedAdvisor?.Subject,
                        "Description": selectedAdvisor?.Description,
                    }
                ]
            }
        }));
        resetForm();
    }

    const handleChange: any = (event: any, field: string) => {
        setSelectedAdvisor({ ...selectedAdvisor, [field]: event })

    }


    const H2: React.FC<{ children: ReactNode; kicker?: string; center?: boolean }> = ({ children, kicker, center }) => (
        <div className={`mb-8 ${center ? "text-center" : ""}`}>
            {kicker && <div className="mb-2 text-sm font-semibold tracking-widest uppercase text-indigo-600">{kicker}</div>}
            <h2 className="text-3xl md:text-4xl font-extrabold text-slate-800">{children}</h2>
        </div>
    );

    return (
        <div id="join" className="bg-gradient-to-b from-slate-50 to-white border-t border-slate-200 px-6">
            <div className="py-16">
                <H2 kicker="Join" center>Talk with us Form</H2>
                <div className="grid lg:grid-cols-3 gap-8">

                    <div className="p-6 bg-white rounded-xl border border-slate-200 shadow-sm lg:col-span-2">
                        <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-6">

                            <>
                                <div>
                                    <label className="text-sm text-slate-600">Full Name</label>
                                    <input
                                        required
                                        type="text"
                                        name="RequestorName"
                                        placeholder="Full Name"
                                        onChange={(event) => handleChange(event.target.value, 'RequestorName')}
                                        value={selectedAdvisor?.RequestorName}
                                        className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                    />
                                </div>

                                <div>
                                    <label className="text-sm text-slate-600">Email</label>
                                    <input
                                        required
                                        type="email"
                                        name="RequestorEmailId"
                                        placeholder="Email"
                                        onChange={(event) => handleChange(event.target.value, 'RequestorEmailId')}
                                        value={selectedAdvisor?.RequestorEmailId}
                                        className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                    />
                                </div>

                                <div>
                                    <label className="text-sm text-slate-600">Phone</label>
                                    <input
                                        required
                                        type="number"
                                        name="RequestorPhoneNo"
                                        placeholder="Phone Number"
                                        onChange={(event) => handleChange(event.target.value, 'RequestorPhoneNo')}
                                        value={selectedAdvisor?.RequestorPhoneNo}
                                        className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                    />

                                </div>

                                <div>
                                    <label className="text-sm text-slate-600">Subject</label>
                                    <input
                                        required
                                        type="text"
                                        name="Subject"
                                        placeholder="Subject"
                                        onChange={(event) => handleChange(event.target.value, 'Subject')}
                                        value={selectedAdvisor?.Subject}
                                        className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                    />
                                </div>

                                <div>
                                    <label className="text-sm text-slate-600">Description</label>
                                    <input
                                        required
                                        type="text"
                                        name="Description"
                                        placeholder="Description"
                                        onChange={(event) => handleChange(event.target.value, 'Description')}
                                        value={selectedAdvisor?.Description}
                                        className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                    />

                                </div>


                            </>

                            <div className="sm:col-span-2 flex justify-center space-x-4">
                                <button
                                    type="submit"
                                    className="inline-flex items-center justify-center px-6 py-3 rounded-xl 
                             bg-indigo-600 text-white font-semibold shadow hover:bg-indigo-700 
                             focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                    {isButtonLoading ? (
                                        <RotatingLines strokeColor="white" strokeWidth="5" animationDuration="0.75" width="24" visible={true} />
                                    ) : (
                                        "Subscribe"
                                    )}
                                </button>

                                <button
                                    type="button"
                                    onClick={() => navigate("/communities")}
                                    className="inline-flex items-center justify-center px-6 py-3 rounded-xl 
               bg-gray-500 text-white font-semibold shadow hover:bg-gray-600 
               focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
                                >
                                    Back
                                </button>
                            </div>
                        </form>
                    </div>

                    {/* Right Info divs */}
                    <div className="space-y-4">
                        <div className="p-6 bg-white rounded-xl border border-slate-200 shadow-sm">
                            <div className="font-semibold text-slate-900">How membership works</div>
                            <ul className="mt-2 text-sm text-slate-600 list-disc pl-5 space-y-1">
                                <li>Free to join. Upgrade to workshops via Academy when needed.</li>
                                <li>Access playbooks, tools, and partner programs.</li>
                                <li>Attend city meetups and online clinics.</li>
                            </ul>
                        </div>

                        <div className="p-6 bg-white rounded-xl border border-slate-200 shadow-sm">
                            <div className="font-semibold text-slate-900">Partner with us</div>
                            <div className="mt-2 text-sm text-slate-600">Banks, logistics, SaaS, and corporates can run clinics, offer credits, and sponsor cohorts.</div>
                            <a href="#" className="mt-3 inline-flex items-center justify-center rounded-full px-4 py-2 border border-slate-300 hover:bg-slate-50 text-sm font-semibold">View Partner Guide</a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};
